import { useRegistrationStore } from '../../hooks';
import { ComponentHeaderView } from '../../components/ComponentHeaderView';

export const ComponentHeader = () => {
  const { onOpenModal } = useRegistrationStore();

  return <ComponentHeaderView handleClickRegistration={onOpenModal} />;
};
